/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FC } from "react";
import Star from "./Star";
import cn from "classnames";

interface Props {
  range?: number; // how many stars [5]
  score: number; // the score [3 out of 5]
  className?: string;
}

const Rating: FC<Props> = ({ range = 5, score, className }) => {
  return (
    <div className={cn("flex gap-x-1", className)}>
      {Array.from({ length: +range }).map((v, i) => {
        const isActive = +score >= i + 1;
        return <Star isActive={isActive} key={i} />;
      })}
    </div>
  );
};

export default Rating;
